<template>
  <app-link
    :to="to"
    class="sidebar-link"
    :class="{ 'is-active': active }"
    :title="collapsed ? label : null"
    :aria-current="active ? 'page' : null"
    @click.native="$emit('select')"
  >
    <lucide-icon
      v-if="icon"
      :icon="icon"
      :size="18"
      class="sidebar-link__icon"
      aria-hidden="true"
    />
    <svg-icon
      v-else-if="fallbackIcon"
      :icon-class="fallbackIcon"
      class-name="sidebar-link__icon"
    />
    <span class="sidebar-link__label">{{ label }}</span>
    <span v-if="active" class="sidebar-link__dot" />
  </app-link>
</template>

<script>
import AppLink from './Link'
import LucideIcon from '@/components/LucideIcon'

export default {
  name: 'SidebarMenuLink',
  components: { AppLink, LucideIcon },
  props: {
    to: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: Array,
      default: null
    },
    fallbackIcon: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    },
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select']
}
</script>
